import { defer } from "react-router-dom";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { queryContract } from "./services";

export function waitingListLoader() {
  return defer({
    coreData: resolveLoaderResult(queryContract()),
  });
}
